import React, { Component } from 'react';
import { Step2Button } from './Setp2Buttons';
import intl from 'react-intl-universal';
import { getParameterByName } from '../../querystring.js';

const locales = {
    'pt-BR': require('../../locales/pt-BR.json'),
    'en-US': require('../../locales/en-US.json'),
    'es-ES': require('../../locales/es-ES.json')
  };

class Step02 extends Component {
    imageUrl = "https://static-files.tracksale.co/npsmachine/images/step2.png";

    constructor() {
        super();

        const querystring = getParameterByName('lang');

        const language = querystring ? querystring : navigator.language;
    
        const currentLocale = locales[language] ? language : 'pt-BR';
    
        intl.init({
          currentLocale,
          locales
        });
      }

    render() {
        return (
            <div className="step row-nps">
                <div className="step2">
                </div>
                <div className="escale">
                    <Step2Button label={intl.get('buttons.detratores')} npsClass="detractor" value={this.props.detractorsValue || 0} />
                    <Step2Button label={intl.get('buttons.neutros')} npsClass="neutral" value={this.props.neutralValue || 0} />
                    <Step2Button label={intl.get('buttons.promotores')} npsClass="promotors" value={this.props.promoterValue || 0} />
                </div>
            </div>
        );

    }
}

export default Step02;